export const historyStartYear = 2000;
export const months = ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"];
export function historyYears(now = new Date()) {
    const year = Number(new Intl.DateTimeFormat("sv-SE", { timeZone: "Europe/Rome", year: "numeric" }).format(now));
    return Array.from({ length: year - historyStartYear + 1 }, (_, index) => year - index);
}
export const periods = [{ text: "Mese", value: "month" }, { text: "Trimestre", value: "quarter" }, { text: "Anno", value: "year" }];
export const quarters = [1, 2, 3, 4].map(value => ({ text: `${value}° trimestre`, value }));

export function periodSelection(filters) {
    const year = Number(filters.period_year || filters.start.slice(0, 4));
    const month = Number(filters.period_month || filters.start.slice(5, 7));
    return { type: filters.period_type || "month", year, month, quarter: Number(filters.period_quarter || Math.ceil(month / 3)) };
}

export function periodFilters(filters, selection, now = new Date()) {
    const { type, year, month, quarter } = selection;
    const firstMonth = type === "year" ? 1 : type === "quarter" ? (quarter - 1) * 3 + 1 : month;
    const length = type === "year" ? 12 : type === "quarter" ? 3 : 1;
    const start = `${year}-${String(firstMonth).padStart(2, "0")}-01`;
    const last = new Date(Date.UTC(year, firstMonth - 1 + length, 0)).toISOString().slice(0, 10);
    const today = new Intl.DateTimeFormat("sv-SE", { timeZone: "Europe/Rome" }).format(now);
    return { ...filters, start, until: today >= start && today < last ? today : last,
        period_type: type, period_year: year, period_month: month, period_quarter: quarter };
}

export function periodLabel(filters) {
    const { type, year, month, quarter } = periodSelection(filters);
    return type === "year" ? `Anno ${year}` : type === "quarter" ? `${quarter}° trimestre ${year}` : `${months[month - 1]} ${year}`;
}

export function periodForToday(filters, now = new Date()) {
    return filters.period_type ? periodFilters(filters, periodSelection(filters), now) : filters;
}

export function coveredRange(start, end, available) {
    if (!available || start >= available.end || end <= available.start) return { start, end };
    return { start: start < available.start ? available.start : start, end: end > available.end ? available.end : end };
}
